/* tslint:disable:indent */
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
// import {ServerResponse} from '../interfaces/ServerResponse';
import {map} from 'rxjs/operators';
import {StringFunctions} from '../functions/string-functions';
// import {ServerError} from '../models/server-error.model';
import {API_ENDPOINTS} from '../api/api-endpoints';
import {Website} from '../models/website.model';
import {Promotion} from '../models/promotion.model';

@Injectable({providedIn: 'root'})
export class WccService {
	getWebsites(): Observable<Website[]> {
		return this.http.post(
			API_ENDPOINTS.WCC.WCC_GET_WEBSITES,
			{}
			)
			.pipe(
				map((response: any) => {
					if (!response.error) {
						return this.toWebsiteArray(response.message);
					} else {
						return [];
					}
				})
			);
	}

	removeWebsite(websiteId: number): Observable<boolean> {
		return this.http.post(
			API_ENDPOINTS.WCC.WCC_REMOVE_WEBSITE,
			{website: websiteId}
		)
			.pipe(
				map((response: any) => {
					if (!response.error) {
						return true;
					} else {
						return false;
					}
				})
			);
	}

	updateWebsite(website: Website): Observable<boolean> {
		return this.http.post(
			API_ENDPOINTS.WCC.WCC_UPDATE_WEBSITE,
			{website}
		)
			.pipe(
				map((response: any) => {
					if (!response.error) {
						return true;
					} else {
						return false;
					}
				})
			);
	}

	private toWebsiteArray(data): Website[] {
		const websites: Website[] = [];
		for (const item of data) {
			websites.push(
				new Website(
					parseInt(item.Id, 10),
					StringFunctions.emptyToNull(item.Name),
					StringFunctions.emptyToNull(item.Url),
					(parseInt(item.IsActive, 10) === 1),
					parseInt(item.LinkedPromotionId, 10),
					StringFunctions.emptyToNull(item.LinkedPromotionName)
				)
			);
		}
		return websites;
	}

	constructor(private http: HttpClient) { }
}
